export default {
    FINISHED   : "已完成",
    UNFINISHED : "未完成",
    PROCESSING : "進行中",
    PENDING: "待結案"
};